import axios from "axios";

export default {
    async SetPaymentProvider(orderId: string, data: {}) {
        const response = await axios.post('/api/cart/v1/order/payment/' + orderId, data);
        console.log(response);
        return response.data;
    }
}